import styled, { css } from 'styled-components';

const dragActive = css`
  border-color: #78e5d5;
`;

const dragReject = css`
  border-color: #e57878;
`;

export const DropContainer = styled.div.attrs({
  className: 'dropzone',
  isDragActive: false,
  isDragReject: false,
})`
  border: 2px dashed rgb(230, 239, 251);
  border-radius: 4px;
  cursor: pointer;

  transition: height 0.2s ease;

  ${(props) => props.isDragActive && dragActive};
  ${(props) => props.isDragReject && dragReject};
`;

const messageColors = {
  default: '#999',
  error: '#e57878',
  success: '#78e5d5',
};

export const UploadMessage = styled.span<{
  type?: 'default' | 'error' | 'success';
}>`
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 1rem;
  color: #333;
  margin: 0;
  margin-bottom: 0;
  padding: 0;
  font-weight: bold;
`;
